export default __webpack_public_path__ + "static/media/seasonal.d2aea53f.jpg";